import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'

import { EUserGroup, IUser, IDialog } from "@/components/shared/types";
import { User } from "@/components/User";

let auid:number = 1; // application unique id
interface IState {
  User: User;
  Page: string;
  Toc?: string;
  Options?: {[key:string] : any}; // Page or Toc specific values
  ForAdmin?: boolean;  // For EcoPlant: to do, use Options instead of
  SelectedApp?: string;
  Dialog?: IDialog;
  ShowMapPaddingCenter?: boolean;
  ShowBackdrop?: boolean;
  WindowWidth?: number;
  Storage?: {[key:string] : string};
};

Vue.use(Vuex);
const localStorage = window.localStorage || null;
let iuser = {
  Avatar: '/static/images/avatar.png', 
  GivenName: 'Anonymous',
  Surname: '',
  Group: EUserGroup.Citizens,
  Settings: {
    Language: navigator ? navigator.language.split('-')[0].toLowerCase() : 'th'
  }
};
if (localStorage) {
  try {
    let item = localStorage.getItem('SoftooLocalStoredUser');
    if (item) {
      iuser = JSON.parse(item);
    }
  } catch (error) {}
}

const stateStorage = store => {
  store.subscribe((mutation, state) => {
    // called after every mutation.
    // The mutation comes in the format of `{ type, payload }`.
    let m = mutation;
    let s = state;
    let localStorage = window.localStorage || null;
    if (localStorage) {

    }
  })
};

const state:IState = {
  WindowWidth: window.innerWidth,
  User: new User(iuser),
  Page: 'home', // home | login | land | map | ecoplant | rice | ...
  ForAdmin: window.localStorage ? (window.localStorage.getItem('softooStateStorageForAdmin')=='true') : false,
  SelectedApp: '',
  Options: null,
  Dialog: {
    show: false,
    wait: false,
    Type: "info",
    OnClose: (answer) => {
      this.$store.commit('notifyChange', {
        Dialog: {
          show: false
        }
      })
    }
  },
  ShowBackdrop: false
}

const store:StoreOptions<IState> = {
  state: state,
  //plugins: [stateStorage],
  mutations: {
    notifyChange(state, payload:IState) {
      for (let p in payload) {
        if (p=='User' && payload[p]) {
          if (payload[p] instanceof User) {
            state.User = payload[p]; // a new user
          } else {
            state.User.Properties = payload[p]; // update properties of existing user
          }
          //todo
          if (localStorage) {
            localStorage.setItem('SoftooLocalStoredUser',JSON.stringify(state.User.Properties));
          }
        } else if (p=='Dialog') {
          //inheritate exiting Type and Title
          state[p] = Object.assign({
            Type: state[p].Type,
            Title: state[p].Title,
            DisableOk: false
          }, payload[p]);
        } else if (p=='Storage') {
          if (localStorage) {
            if (payload[p]) {
              localStorage.setItem('SoftooLocalStoredCache', JSON.stringify(payload[p]));
            } else {
              localStorage.removeItem('SoftooLocalStoredCache');
            }
          }
        } else if (p=='Language') {
          state.User.Settings.Language = payload[p];
        } else {
          state[p] = payload[p];
        }
        /*
        if (localStorage) {
          if (p=='ForAdmin') {
            localStorage.setItem('softooStateStorageForAdmin',payload[p]+'');
          }
        }*/
      }
    }
  },
  getters: {
    auid(state) : number {
      return auid++;
    },
    Language(state) : string {
      return state.User.Language;
    },
    User(state) : User {
      return state.User;
    },
    Page(state) : string {
      return state.Page;
    },
    ForAdmin(state) : boolean {
      return state.ForAdmin;
    },
    SelectedApp(state) : string {
      return state.SelectedApp;
    },
    Storage(state) : {[key:string] : string} {
      let s:{[key:string] : string} = null;
      if (localStorage) {
        let item = localStorage.getItem('SoftooLocalStoredCache');
        if (item) {
          s = JSON.parse(item);
        }
      }
      return s;
    },
    Options(state) : {[key:string] : any} {
      return state.Options;
    },
    UserData(state) : {[key:string] : any} {
      return state.Options ? state.Options.UserData : null;
    },
    Dialog(state) : IDialog {
      return state.Dialog;
    },
    WindowWidth(state) : number {
      return state.WindowWidth;
    },
    ShowMapPaddingCenter(state) : boolean {
      return state.ShowMapPaddingCenter;
    },
    ShowBackdrop(state) : boolean {
      return state.ShowBackdrop;
    }
  }
}

export default new Vuex.Store<IState>(store);
